import React, { useEffect, useRef } from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import Image from "gatsby-image"
import BackgroundImage from "gatsby-background-image"
import SEO from "../components/seo"
import { useStaticQuery, graphql } from "gatsby"
import punchSonud from "../spacepics/punch.mp3"
import { useLocation } from "@reach/router"
import "../styles/index.css"
import "../styles/stars.css"
import GetHeader from "../components/getHeader"
import { trackCustomEvent, OutboundLink } from "gatsby-plugin-google-analytics"

import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

function age(birthdate) {
  const today = new Date();
  const age = today.getFullYear() - birthdate.getFullYear() - 
             (today.getMonth() < birthdate.getMonth() || 
             (today.getMonth() === birthdate.getMonth() && today.getDate() < birthdate.getDate()));
  return age;
}
const birthdate = new Date(1998, 11, 17); 

const Homepage = (props) => {
  const location = useLocation()
  const wasRedirected = location.action === "PUSH" && !location.state.noChange ? true : null

  const wasClickedShowPortfolio = useRef({ value: false, times: 0 })
  const timeouts = useRef({ cubeTimeout1: null, cubeTimeout2: null, asteroidTimeout1: null, asteroidTimeout2: null, asteroidTimeout3: null })

  useEffect(() => {
    if (wasRedirected) {
      const darkness = document.getElementById("darkness")
      if (darkness) setTimeout(() => document.getElementById("darkness").remove(), 50)
    }

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/ false || !!document.documentMode
    // IF IT IS EDGE SO
    if ((!isIE && !!window.StyleMedia) || isIE) {
      document.getElementById("homepage").classList.add("explorer")
    }

    // Target when contents is on screen, and then fade in animation
    const cube = document.getElementById("cube")

    const observerCube = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio > 0.9 && !wasClickedShowPortfolio.current.value && wasClickedShowPortfolio.current.times === 0) {
            wasClickedShowPortfolio.current.times++

            timeouts.current.cubeTimeout1 = setTimeout(() => {
              cube.classList.add("onload")

              timeouts.current.cubeTimeout2 = setTimeout(() => {
                cube.classList.add("afterload")
                document.getElementById("cube_bottom").classList.add("afterload")
                observerCube.disconnect()
              }, 4450)
            }, 500)
          }
        })
      },
      { threshold: [0.9] }
    )

    observerCube.observe(cube)

    // ALL THE TECH PICTURES
    const techs = document.getElementsByClassName("specificTech")
    const observerTechs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          entry.target.classList.add("fadeIn")
        }
      })
    })
    for (let tech of techs) {
      observerTechs.observe(tech)
    }

    return () => {
      if (wasClickedShowPortfolio.current.times !== 0) {
        observerCube.disconnect()
        wasClickedShowPortfolio.current = { value: false, times: 0 }
      }
      observerTechs.disconnect()
      clearTimeout(timeouts.current.cubeTimeout1)
      clearTimeout(timeouts.current.cubeTimeout2)
      clearTimeout(timeouts.current.asteroidTimeout1)
      clearTimeout(timeouts.current.asteroidTimeout2)
      clearTimeout(timeouts.current.asteroidTimeout3)
    }
  }, [wasRedirected])

  const {
    spaceship: {
      childImageSharp: { fixed: spaceship },
    },
    asteroid: {
      childImageSharp: { fixed: asteroid },
    },
    alien: {
      childImageSharp: { fixed: alien },
    },
    messagespaceship: {
      childImageSharp: { fixed: messageSpaceship },
    },
    alienstand: {
      childImageSharp: { fixed: alienStand },
    },
    bloodStain: {
      childImageSharp: { fixed: bloodStain },
    },
    downarrow: {
      childImageSharp: { fixed: downArrow },
    },
    myPic: {
      childImageSharp: { fixed: myPic },
    },
    getTestimonials: { testimonials },
    getProjects: { listProjects },
    getCubePics: { cubePics },
    getExternalPics: { nodes: externalPics },
    arrowUp: {
      childImageSharp: { fixed: arrowUp },
    },
    emailPic: {
      childImageSharp: { fixed: emailPic },
    },
  } = useStaticQuery(graphql`
    {
      spaceship: file(relativePath: { eq: "spaceship.png" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      asteroid: file(relativePath: { eq: "asteroid.png" }) {
        childImageSharp {
          fixed(width: 150) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      alien: file(relativePath: { eq: "alien.png" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      messagespaceship: file(relativePath: { eq: "messageSpaceship.png" }) {
        childImageSharp {
          fixed(height: 140) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      alienstand: file(relativePath: { eq: "alienStand.png" }) {
        childImageSharp {
          fixed(width: 200) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      bloodStain: file(relativePath: { eq: "bloodStain.png" }) {
        childImageSharp {
          fixed(width: 100) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      downarrow: file(relativePath: { eq: "downarrow.png" }) {
        childImageSharp {
          fixed(width: 50) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      myPic: file(relativePath: { eq: "myPic.png" }) {
        childImageSharp {
          fixed(width: 90) {
            ...GatsbyImageSharpFixed_tracedSVG
          }
        }
      }
      getTestimonials: allContentfulTestimonials {
        testimonials: nodes {
          nameGiver
          picGiver
          text {
            text
          }
          countryGiver
          title
        }
      }
      getProjects: allContentfulProjectsList {
        listProjects: nodes {
          projectsList {
            heTitle
            enTitle
            uriLink
            heSlug
            enSlug
            introPic {
              fluid(maxWidth: 1300) {
                ...GatsbyContentfulFluid
              }
            }
          }
          techList {
            image {
              title
              fixed(height: 70) {
                ...GatsbyContentfulFixed
              }
            }
          }
        }
      }
      getCubePics: contentfulCube {
        cubePics: pics {
          name
          image {
            fixed(width: 225) {
              ...GatsbyContentfulFixed_tracedSVG
            }
          }
        }
      }
      getExternalPics: allFile(filter: { sourceInstanceName: { eq: "externals" } }, sort: { fields: [relativePath], order: ASC }) {
        nodes {
          childImageSharp {
            fixed(height: 25) {
              ...GatsbyImageSharpFixed
            }
          }
        }
      }
      arrowUp: file(relativePath: { eq: "arrowUp.png" }) {
        childImageSharp {
          fixed(width: 25) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      emailPic: file(relativePath: { eq: "email.png" }) {
        childImageSharp {
          fixed(height: 26, grayscale: true) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)

  const { projectsList, techList } = listProjects[0]

  let activateAsteroid = () => {
    document.getElementsByClassName("asteroid")[0].classList.add("falling")
    timeouts.current.asteroidTimeout1 = setTimeout(() => document.getElementsByClassName("alien")[0].classList.add("dead"), 2300)
    document.getElementById("dontpush").classList.add("clicked")

    var audioElement = new Audio(punchSonud)
    audioElement.volume = 0.1
    timeouts.current.asteroidTimeout2 = setTimeout(() => audioElement.play(), 1350)
    timeouts.current.asteroidTimeout3 = setTimeout(() => {
      document.getElementById("alienArea").style.overflow = "hidden"
      document.getElementsByClassName("bloodStain")[0].classList.add("growing")
    }, 3250)
  }
  // When clicked on VIEW PORTFOLIO, setting this to WasClicked to true, to avoid the bug of getting stuck in the cube animation(scrollBy), then after passed the cube set it to False
  let handleMoveToPortfolio = (e) => {
    e.preventDefault()
    document.getElementById("portfolio").scrollIntoView() // this is used to avoid bug of gatsby in line 180 so scrolling by dom

    wasClickedShowPortfolio.current.value = true
    setTimeout(() => {
      wasClickedShowPortfolio.current.value = false
    }, 700)
  }

  let sendAnalytics = (title) => {
    trackCustomEvent({
      category: "Opened Project Details",
      action: "Click",
      label: title,
    })
  }

  // settings for react slick carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    accessibility: true,
    responsive: [
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  }

  let changeCursorToGrab = () => {
    document.getElementsByClassName("slick-list")[0].style.cursor = "grabbing"
  }

  let changeGrabToUngrab = () => {
    document.getElementsByClassName("slick-list")[0].style.cursor = "grab"
  }

  if (props.pageContext.hebrew) {
    return (
      <Layout>
        <div id="homepage" className={wasRedirected ? "rollingPage active" : "rollingPage"}>
          <SEO
            title="פורטפוליו"
            keywords={["10fastfingers", "typeracer", "מקליד הכי מהיר בעברית", "הקלדה מהירה"]}
            description="תיק עבודות/פורטפוליו של איתי שיף. מפתח פרונד אנד (מפתח צד לקוח) ושרת מלימוד עצמי."
          />

          <GetHeader />
          <section className="wrapper">
            <Image fixed={spaceship} alt="חללית" />
            <div id="stars"></div>
            <div id="starsStatic"></div>

            <div id="innerWrapperContent">
              <h1>איתי שיף</h1>
              <h2>Full Stack Developer</h2>
            </div>
            <a href="#portfolio" onClick={handleMoveToPortfolio}>
              <span>צפה בתיק עבודות</span>
              <Image fixed={downArrow} alt="חץ למטה קפוץ לפרוייקטים" />
              <Image fixed={downArrow} alt="חץ למטה קפוץ לפרוייקטים" />
            </a>

            <div id="alienArea">
              <Image fixed={alienStand} imgStyle={{ transform: "rotateZ(-150deg)" }} alt="אדמת קרקע של החייזר" />
              <Image fixed={bloodStain} imgStyle={{ opacity: "0.5", transform: "rotateZ(230deg)" }} className="bloodStain" alt="כתם דם" />
              <Image fixed={alien} imgStyle={{ opacity: "0.4" }} style={{ left: "-152px", bottom: "127px" }} className="alien" alt="חייזר" />
            </div>
            <Image fixed={asteroid} className="asteroid" alt="אסטרואיד" />

            <div id="welcomeMessage">
              <h1 className="hebrew">ברוכים הבאים לתיק העבודות שלי!</h1>
              <Image fixed={messageSpaceship} className="flyingMessagePic" imgStyle={{ opacity: "0.3" }} style={{ transform: "rotateZ(90deg)" }} alt="הודעה מהחללית" />
            </div>

            <div id="dontpushWrapper">
              <div id="dontpush" onClick={activateAsteroid} role="button" tabIndex={0}>
                <div id="clickShadowBottom"></div>
                <div id="clickShadowTop">
                  לא
                  <br />
                  ללחוץ
                </div>
              </div>
            </div>
          </section>
          <div id="mySkills" className="hebrew">
            <h1>המיומנויות שלי</h1>
            <div>
              <div forcontent="true" className="hebrew">
                <p>יצא לי לראות הרבה מפתחים שאוהבים לדרג את עצמם בכל סוג של טכנולוגיה שקיימת בתחום.</p>
                <p>לדעתי, זה לא נכון לעשות זאת משום שאני מאמין שתמיד יש מקום להשתפר.</p>
                <p>לכן, במקום זאת אתן לכם את האופציה לדרג אותי. הרגישו חופשי לעיין בפרויקטים שיצרתי ולהתרשם!</p>
              </div>
              <div id="cubeContainer">
                <div id="cube">
                  <div className="cubePEHA" id="cube_front">
                    <Image fixed={cubePics[0].image.fixed} alt={cubePics[0].name} title={cubePics[0].name} />
                    {/* HTML */}
                  </div>
                  <div className="cubePEHA" id="cube_back">
                    <Image fixed={cubePics[1].image.fixed} alt={cubePics[1].name} title={cubePics[1].name} />
                    {/* CSS */}
                  </div>
                  <div className="cubePEHA" id="cube_right">
                    <Image fixed={cubePics[2].image.fixed} alt={cubePics[2].name} title={cubePics[2].name} />
                    {/* VANILLA JS */}
                  </div>
                  <div className="cubePEHA" id="cube_left">
                    <Image fixed={cubePics[3].image.fixed} alt={cubePics[3].name} title={cubePics[3].name} />
                    {/* REACT JS */}
                  </div>
                  <div className="cubePEHA" id="cube_top"></div>
                  <div className="cubePEHA" id="cube_bottom">
                    <Image fixed={cubePics[4].image.fixed} alt={cubePics[4].name} title={cubePics[4].name} />
                    {/* GATSBY */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="testimonials">
            <h1>המלצות מאנשים שעבדתי איתם</h1>
            <Slider {...settings}>
              {testimonials.map((testimonial) =>
                <div className="specificTestimonial" key={testimonial.nameGiver} onMouseDown={changeCursorToGrab} onMouseUp={changeGrabToUngrab} role="slider" tabIndex={0}>
                  <div>
                    <img src={testimonial.picGiver} width="50" />
                    <span>{testimonial.nameGiver}</span>
                    <img src={testimonial.countryGiver} width="40" />
                  </div>
                  <div className="titleTestimonial">{testimonial.title}</div>
                  <p>
                    {testimonial.text.text}
                  </p>
                  <div className="starsTestimonial"><span>5.0</span> ★★★★★</div>
                </div>
              )}
            </Slider>
          </div>

          <div id="techKnown">
            <h1>טכנולוגיות שהתנסיתי בהם</h1>
            <div>
              {techList.map((tech) => (
                <div key={tech.image.title} className="specificTech">
                  <Image fixed={tech.image.fixed} alt={tech.image.title} title={tech.image.title} />
                  <h3>{tech.image.title}</h3>
                </div>
              ))}
            </div>
          </div>
          <div id="portfolio">
            <h1>פורטפוליו - תיק העבודות שלי</h1>
            <h6>לחץ על פרוייקט כדי להרחיב עליו במידע</h6>
            {projectsList.map((project, index) => (
              <BackgroundImage Tag={`section`} className="project" fluid={project.introPic.fluid} key={index}>
                <div className="innerProjectHover">
                  <h2>{project.heTitle}</h2>
                  <div className="links">
                    {project.uriLink !== "none" && (
                      <OutboundLink href={project.uriLink} target="_blank" rel="noopener noreferrer">
                        <button>עבור לאתר</button>
                      </OutboundLink>
                    )}
                    <Link to={`/he/projects/${project.heSlug}`} onClick={() => sendAnalytics(project.heTitle)}>
                      <button>פרטי הפרוייקט</button>
                    </Link>
                  </div>
                </div>
              </BackgroundImage>
            ))}
          </div>
          <footer className="hebrew">
            <div id="footerCover"></div>

            <div id="credit">איתי שיף 2020 כל הזכויות שמורות ©</div>
            <div id="arrowUp" onClick={() => window.scrollTo(0, 0)}>
              <Image fixed={arrowUp} alt="קפוץ לתחילת העמוד" />
            </div>
            <a href="mailto:itaysbusiness@gmail.com" id="email">
              <Image fixed={emailPic} alt="שלח אימייל לאיתי שיף" title="שלח אימייל לאיתי שיף" />
            </a>

            <div id="innerFooter">
              <div className="flexed">
                <div>
                  <span>
                    <Image fixed={myPic} alt="איתי שיף תמונת פרופיל" />
                  </span>
                  <div>
                    <h1>
                      <b>איתי שיף, Full Stack Developer</b>
                    </h1>
                    <br />
                    מלימוד עצמי, בן {age(birthdate)}
                    <br />
                    מקום 1 בהקלדה מהירה בעברית
                    <br />
                    מקום 78 בהקלדה מהירה באנגלית
                  </div>
                </div>
                <div forquote="true">
                  <b>"אם זה לא מאתגר אותך זה לא ישנה אותך"</b>
                </div>
              </div>

              <div className="flexed">
                <b>עמודים</b>
                <Link to="/he/about" state={{ noChange: true }}>
                  אודות
                </Link>
                <a href="#portfolio" onClick={handleMoveToPortfolio}>
                  הפרוייקטים שלי
                </a>
                <Link to="/he/contact" state={{ noChange: true }}>
                  צור קשר
                </Link>
              </div>

              <div className="flexed">
                <div>
                  <b>לינקיים חיצוניים</b>
                  <div>
                    <OutboundLink href="https://www.linkedin.com/in/itayshiff/" target="_blank" rel="noopener noreferrer">
                      <Image fixed={externalPics[0].childImageSharp.fixed} alt="Itay Shiff LinkedIn Account לינקדאין" title="Itay Shiff LinkedIn Account" />
                      LinkedIn
                    </OutboundLink>
                  </div>

                  <div>
                    <OutboundLink href="https://www.instagram.com/itayshiff/" target="_blank" rel="noopener noreferrer">
                      <Image fixed={externalPics[1].childImageSharp.fixed} alt="Itay Shiff Instagram אינסטגרם" title="Itay Shiff Instagram Account" />
                      Instagram
                    </OutboundLink>
                  </div>

                  <div>
                    <OutboundLink href="https://www.freelancer.com/u/Itay2468" target="_blank" rel="noopener noreferrer">
                      <Image fixed={externalPics[2].childImageSharp.fixed} alt="Itay Shiff Freelancer פרילנסר" title="Itay Shiff Freelancer Account" />
                      Freelancer
                    </OutboundLink>
                  </div>

                  <div>
                    <OutboundLink href="https://data.typeracer.com/pit/profile?user=itay2468" target="_blank" rel="noopener noreferrer">
                      <Image fixed={externalPics[3].childImageSharp.fixed} alt="Itay Shiff TypeRacer הקלדה מהירה טייפרייסר" title="Itay Shiff TypeRacer Account" />
                      TypeRacer
                    </OutboundLink>
                  </div>

                  <div>
                    <OutboundLink href="https://10fastfingers.com/user/306954" target="_blank" rel="noopener noreferrer">
                      <Image fixed={externalPics[4].childImageSharp.fixed} alt="Itay Shiff 10fastfingers הקלדה מהירה 10פסטפינגרס" title="Itay Shiff 10fastfingers Account" />
                      10fastfingers
                    </OutboundLink>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>

        {wasRedirected && <div id="darkness"></div>}
      </Layout>
    )
  }

  // Else render it in English
  return (
    <Layout>
      <div id="homepage" className={wasRedirected ? "rollingPage active" : "rollingPage"}>
        <SEO title="Portfolio" keywords={["10fastfingers", "typeracer", "Fast typing", "fastest typist in hebrew"]} />

        <GetHeader />

        <section className="wrapper">
          <Image fixed={spaceship} alt="spaceship" />
          <div id="stars"></div>
          <div id="starsStatic"></div>

          <div id="innerWrapperContent">
            <h1>Itay Shiff</h1>
            <h2>Full Stack Developer</h2>
          </div>
          <a href="#portfolio" onClick={handleMoveToPortfolio}>
            <span>VIEW PORTFOLIO</span>
            <Image fixed={downArrow} alt="down arrow jump to projects" />
            <Image fixed={downArrow} alt="down arrow jump to projects" />
          </a>

          <div id="alienArea">
            <Image fixed={alienStand} imgStyle={{ transform: "rotateZ(-150deg)" }} alt="alien's ground" />
            <Image fixed={bloodStain} imgStyle={{ opacity: "0.5", transform: "rotateZ(230deg)" }} className="bloodStain" alt="blood stain" />
            <Image fixed={alien} imgStyle={{ opacity: "0.4" }} style={{ left: "-152px", bottom: "127px" }} className="alien" alt="alien" />
          </div>
          <Image fixed={asteroid} className="asteroid" alt="asteroid" />

          <div id="welcomeMessage">
            <h1>Welcome to my portfolio!</h1>
            <Image fixed={messageSpaceship} className="flyingMessagePic" imgStyle={{ opacity: "0.3" }} style={{ transform: "rotateZ(90deg)" }} alt="message from spaceship" />
          </div>

          <div id="dontpushWrapper">
            <div id="dontpush" onClick={activateAsteroid} role="button" tabIndex={0}>
              <div id="clickShadowBottom"></div>
              <div id="clickShadowTop">
                DON'T
                <br />
                PUSH
              </div>
            </div>
          </div>
        </section>

        <div id="mySkills">
          <h1>My Skillset</h1>
          <div>
            <div forcontent="true">
              <p>I see many developers out there that like rating themselves at any technology field in this section.</p>
              <p>In my point of view, it's not right to do so because I believe there's always room for improvement.</p>
              <p>Instead, I'll let you browse in my projects so that you can judge and tell about my skills.</p>
            </div>
            <div id="cubeContainer">
              <div id="cube">
                <div className="cubePEHA" id="cube_front">
                  <Image fixed={cubePics[0].image.fixed} alt={cubePics[0].name} title={cubePics[0].name} />
                  {/* HTML */}
                </div>
                <div className="cubePEHA" id="cube_back">
                  <Image fixed={cubePics[1].image.fixed} alt={cubePics[1].name} title={cubePics[1].name} />
                  {/* CSS */}
                </div>
                <div className="cubePEHA" id="cube_right">
                  <Image fixed={cubePics[2].image.fixed} alt={cubePics[2].name} title={cubePics[2].name} />
                  {/* VANILLA JS */}
                </div>
                <div className="cubePEHA" id="cube_left">
                  <Image fixed={cubePics[3].image.fixed} alt={cubePics[3].name} title={cubePics[3].name} />
                  {/* REACT JS */}
                </div>
                <div className="cubePEHA" id="cube_top"></div>
                <div className="cubePEHA" id="cube_bottom">
                  <Image fixed={cubePics[4].image.fixed} alt={cubePics[4].name} title={cubePics[4].name} />
                  {/* GATSBY */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="testimonials">
          <h1>Testimonials</h1>
          <Slider {...settings}>
            {testimonials.map((testimonial) =>
              <div className="specificTestimonial" key={testimonial.nameGiver} onMouseDown={changeCursorToGrab} onMouseUp={changeGrabToUngrab} role="slider" tabIndex={0}>
                <div>
                  <img src={testimonial.picGiver} width="50" />
                  <span>{testimonial.nameGiver}</span>
                  <img src={testimonial.countryGiver} width="40" />
                </div>
                <div className="titleTestimonial">{testimonial.title}</div>
                <p>
                  {testimonial.text.text}
                </p>
                <div className="starsTestimonial"><span>5.0</span> ★★★★★</div>
              </div>
            )}
          </Slider>
        </div>

        <div id="techKnown">
          <h1>Technologies I experienced with</h1>
          <div>
            {techList.map((tech) => (
              <div key={tech.image.title} className="specificTech">
                <Image fixed={tech.image.fixed} alt={tech.image.title} title={tech.image.title} />
                <h3>{tech.image.title}</h3>
              </div>
            ))}
          </div>
        </div>

        <div id="portfolio">
          <h1>Portfolio - My Projects List</h1>
          <h6>Click on a project to show details</h6>
          {projectsList.map((project, index) => (
            <BackgroundImage Tag={"section"} className="project" fluid={project.introPic.fluid} key={index}>
              <div className="innerProjectHover">
                <h2>{project.enTitle}</h2>
                <div className="links">
                  {project.uriLink !== "none" && (
                    <OutboundLink href={project.uriLink} target="_blank" rel="noopener noreferrer">
                      <button>Move to Site</button>
                    </OutboundLink>
                  )}
                  <Link to={`/projects/${project.enSlug}`} onClick={() => sendAnalytics(project.enTitle)}>
                    <button>Project Details</button>
                  </Link>
                </div>
              </div>
            </BackgroundImage>
          ))}
        </div>

        <footer>
          <div id="footerCover"></div>

          <div id="credit">2020 Itay Shiff © All Rights Reserved</div>
          <div id="arrowUp" onClick={() => window.scrollTo(0, 0)}>
            <Image fixed={arrowUp} alt="arrow up, jump to top page" />
          </div>
          <a href="mailto:itaysbusiness@gmail.com" id="email">
            <Image fixed={emailPic} alt="Send email to Itay Shiff" title="Send email to Itay Shiff" />
          </a>

          <div id="innerFooter">
            <div className="flexed">
              <div>
                <span>
                  <Image fixed={myPic} alt="itay shiff profile picture" />
                </span>
                <div>
                  <h1>
                    <b>Itay Shiff, Full Stack Developer</b>
                  </h1>
                  <br />
                  Self taught, {age(birthdate)} years old
                  <br />
                  1st Fastest typist in Hebrew (150wpm)
                  <br />
                  78th Fastest typist in English (170wpm)
                </div>
              </div>
              <div forquote="true">
                <b>"What doesn't challenge you won't change you"</b>
              </div>
            </div>

            <div className="flexed">
              <b>Pages</b>
              <Link to="/about" state={{ noChange: true }}>
                About Me
              </Link>
              <a href="#portfolio" onClick={handleMoveToPortfolio}>
                My Projects
              </a>
              <Link to="/contact" state={{ noChange: true }}>
                Contact Me
              </Link>
            </div>

            <div className="flexed">
              <div>
                <b>External Links</b>
                <div>
                  <OutboundLink href="https://www.linkedin.com/in/itayshiff/" target="_blank" rel="noopener noreferrer">
                    <Image fixed={externalPics[0].childImageSharp.fixed} alt="Itay Shiff LinkedIn Account" title="Itay Shiff LinkedIn Account" />
                    LinkedIn
                  </OutboundLink>
                </div>

                <div>
                  <OutboundLink href="https://www.instagram.com/itayshiff/" target="_blank" rel="noopener noreferrer">
                    <Image fixed={externalPics[1].childImageSharp.fixed} alt="Itay Shiff Instagram" title="Itay Shiff Instagram Account" />
                    Instagram
                  </OutboundLink>
                </div>

                <div>
                  <OutboundLink href="https://www.freelancer.com/u/Itay2468" target="_blank" rel="noopener noreferrer">
                    <Image fixed={externalPics[2].childImageSharp.fixed} alt="Itay Shiff Freelancer" title="Itay Shiff Freelancer Account" />
                    Freelancer
                  </OutboundLink>
                </div>

                <div>
                  <OutboundLink href="https://data.typeracer.com/pit/profile?user=itay2468" target="_blank" rel="noopener noreferrer">
                    <Image fixed={externalPics[3].childImageSharp.fixed} alt="Itay Shiff TypeRacer" title="Itay Shiff TypeRacer Account" />
                    TypeRacer
                  </OutboundLink>
                </div>

                <div>
                  <OutboundLink href="https://10fastfingers.com/user/306954" target="_blank" rel="noopener noreferrer">
                    <Image fixed={externalPics[4].childImageSharp.fixed} alt="Itay Shiff 10fastfingers" title="Itay Shiff 10fastfingers Account" />
                    10fastfingers
                  </OutboundLink>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>

      {wasRedirected && <div id="darkness"></div>}
    </Layout>
  )
}

export default Homepage
